export class ArchivoASubir {
    valor: string;
    extension: string;
    codigo: number
};